import { isValid } from 'date-fns';
import { format, toZonedTime } from 'date-fns-tz';

export type PrettyScheduleDateTimeParts = {
  date: string;
  time: string;
};

/** Parses and validates a schedule timestamp; no timezone conversion. */
export const cleanScheduleDateTimeInput = (date: Date | string | null | undefined): Date | null => {
  if (date === null || date === undefined) return null;
  const normalized = new Date(date);
  if (!isValid(normalized)) return null;
  return normalized;
};

/** Formats a schedule date/time for display; returns plain strings (SSR-safe). */
export const prettyScheduleDateTime = (
  date: Date | string | null | undefined,
  timeZone?: string,
): PrettyScheduleDateTimeParts | null => {
  const cleaned = cleanScheduleDateTimeInput(date);
  if (!cleaned) return null;
  const zoned = timeZone ? toZonedTime(cleaned, timeZone) : cleaned;
  return {
    date: format(zoned, 'EEE MMM dd'),
    time: format(zoned, 'HH:mm'),
  };
};
